import { Controller } from "@hotwired/stimulus"
import {get} from "@rails/request.js";

// Connects to data-controller="home-custom-listing"
export default class extends Controller {

  static values = {
    url: String,
  }
  connect() {
    this.renderListing();
  }

  async renderListing(){
    const url = this.urlValue;
    get(url, {
      contentType: "application/json",
      responseKind: "turbo-stream",
    });
  }
}
